import { Button } from "@ui/shad"
import { cn } from "@ui/utils"
import { Check } from "lucide-react"

import { useActionLink, useExecuteActionLink } from "@/hooks/api/action-links"

interface ModifyRecordProps {
  id: string
}

export default function ModifyRecord({ id }: ModifyRecordProps) {
  const { data: actionLink } = useActionLink(id)
  const { mutate: execute, isPending, isSuccess } = useExecuteActionLink()

  if (!actionLink) return null

  const isExecuted = !!actionLink.executed_at || isSuccess
  const isExpired = new Date(actionLink.expires_at) < new Date()
  const isDisabled = isPending || isExecuted || isExpired

  const getButtonVariant = () => {
    if (isExecuted) return "secondary"
    if (isExpired) return "secondary"
    return "outline"
  }

  const getButtonClassName = () => {
    if (isExecuted)
      return "cursor-default border-green-border bg-green-background text-green-foreground hover:bg-green-border"
    if (isExpired) return "cursor-default border-tertiary bg-tinted text-muted-foreground hover:bg-tinted"
    return ""
  }

  const getButtonContent = () => {
    if (isPending) return "Applying..."
    if (isExecuted) {
      return (
        <>
          <Check />
          Changes applied
        </>
      )
    }
    if (isExpired) return "Expired"
    return "Apply changes"
  }

  return (
    <Button
      variant={getButtonVariant()}
      onClick={() => !isDisabled && execute({ id })}
      disabled={isDisabled}
      className={cn("transition-all", getButtonClassName())}
    >
      {getButtonContent()}
    </Button>
  )
}
